import React from "react";
import Notification from "../Component/Notification";

const MainNotifications = () => <Notification />;

export default MainNotifications;
